/**
 * Strings utilisateur de la section Nextore (anciennement "Clés API").
 * Centralisées ici pour la cohérence de ton et une future extraction i18n.
 */
export const copy = {
  pageTitle: 'Nextore',
  pageSubtitle:
    'Les clés Nextore permettent à une intégration — caisse, widget de réservation ou partenaire — de communiquer avec votre organisation.',
  createButton: 'Créer une clé Nextore',
  createDisabledTooltip: (limit: number) =>
    `Vous avez atteint la limite de ${limit} clés — révoquez-en une inutilisée avant d'en créer une nouvelle.`,

  emptyHeadline: 'Aucune clé Nextore pour le moment.',
  emptyBody:
    'Créez votre première clé pour permettre à une intégration Nextore de communiquer avec votre organisation.',
  emptyCta: 'Créer ma première clé',

  errorHeadline: 'Impossible de charger vos clés Nextore.',
  errorCta: 'Réessayer',

  showRevoked: (count: number) => `Afficher les clés révoquées (${count})`,
  hideRevoked: 'Masquer les clés révoquées',

  status: {
    active: 'Active',
    revoked: 'Révoquée',
    expired: 'Expirée',
    stale: 'Inutilisée',
  },
  staleLabel: (days: number) => `Inutilisée depuis ${days} jours`,
  neverUsed: 'Jamais utilisée',
  today: "Aujourd'hui",
  yesterday: 'Hier',
  daysAgo: (days: number) => `Il y a ${days} jours`,
  systemUser: 'système',

  columns: {
    status: 'Statut',
    name: 'Nom',
    environment: 'Env.',
    used: 'Utilisée',
    createdBy: 'Créée par',
    actions: '',
  },

  environment: {
    live: 'Production',
    test: 'Test',
  },

  actionsMenuLabel: 'Actions sur la clé',
  revokeAction: 'Révoquer',

  revokeConfirm: {
    title: 'Révoquer cette clé ?',
    body: 'Cette clé cessera de fonctionner dans les 10 secondes. Les intégrations qui l\u2019utilisent échoueront jusqu\u2019à ce qu\u2019une nouvelle clé soit créée.',
    confirm: 'Révoquer la clé',
    cancel: 'Annuler',
  },

  create: {
    title: 'Créer une clé Nextore',
    nameLabel: 'À quoi servira cette clé ?',
    namePlaceholder: 'ex. Caisse Nextore',
    scopesLabel: 'Que pourra faire cette clé ?',
    environmentLabel: 'Environnement',
    environmentHelp:
      'Les clés de production fonctionnent sur les données réelles. Les clés de test ne fonctionnent que sur les organisations de staging.',
    expiryLabel: 'Expiration (optionnel)',
    expiryNever: 'Jamais',
    expiry30: '30 jours',
    expiry60: '60 jours',
    expiry90: '90 jours',
    submit: 'Créer la clé',
    cancel: 'Annuler',
    serverError: 'Impossible de créer la clé — veuillez réessayer.',
    nameRequired: 'Veuillez donner un nom à cette clé.',
    scopesRequired: 'Sélectionnez au moins une permission.',
  },

  success: {
    headline: 'Votre clé Nextore est prête.',
    body: 'Enregistrez-la dans votre gestionnaire de mots de passe ou transmettez-la à votre partenaire d\u2019intégration maintenant. Elle ne sera plus affichée.',
    copyButton: 'Copier dans le presse-papiers',
    copiedButton: 'Copiée',
    downloadButton: 'Télécharger en .txt',
    downloadedButton: 'Téléchargée',
    footer:
      'Si vous la perdez : révoquez cette clé et créez-en une nouvelle. L\u2019ancienne clé reste valide tant qu\u2019elle n\u2019est pas révoquée.',
    done: 'Terminé',
    clipboardFailed:
      'Impossible de copier automatiquement — la clé est sélectionnée, appuyez sur Cmd+C / Ctrl+C.',
    ariaAnnounce: 'Clé Nextore copiée dans le presse-papiers',
    doneDisabledTooltip:
      'Copiez ou téléchargez la clé avant de fermer cette fenêtre.',
  },

  exitUnsaved: {
    title: 'Vous n\u2019avez pas encore sauvegardé cette clé.',
    body: 'Fermer cette fenêtre la perdra définitivement. Continuer ?',
    confirm: 'Fermer quand même',
    cancel: 'Garder la fenêtre ouverte',
  },

  selectOrgPrompt: 'Sélectionnez une organisation pour gérer les clés Nextore.',
  revokedToast: (name: string) => `${name} révoquée`,
  revokeErrorToast: 'Impossible de révoquer la clé',

  scopes: {
    'nextore:read': {
      label: 'Lire les réservations',
      description:
        'Permet de récupérer les clubs, terrains et parties via les endpoints Nextore.',
    },
    'nextore:write': {
      label: 'Enregistrer des paiements',
      description:
        'Permet d\u2019enregistrer les paiements de la caisse et d\u2019ajouter des joueurs aux parties.',
    },
  } as Record<string, { label: string; description: string }>,
};
